__webpack_require__.p = "https://design-system.dev.ads-dev.sportradar.com/";